<script lang="ts">
  import BaseScene from "@engine/BaseScene.svelte";
  import { STORAGE_KEYS } from "@config/constants/storage";
  import gameInfo from "@config/game_info.json";

  export let onAcknowledge: () => void;

  function acknowledge(): void {
    try {
      window.localStorage.setItem(STORAGE_KEYS.FIRST_LAUNCH_ACK, JSON.stringify({ ts: Date.now() }));
    } catch {
      // storage denied is fine
    }
    onAcknowledge();
  }
</script>

<BaseScene sceneId="first-launch" ariaLabel="Before you play advisory">
  <div class="advisory">
    <h1 class="advisory__title">Before you play</h1>

    <section class="advisory__section" aria-labelledby="photosens-h">
      <h2 id="photosens-h">Photosensitive epilepsy</h2>
      <p>
        This game uses colorful animation and short flashes when you match a creature.
        If you or a family member has a history of photosensitive epilepsy, please play
        at a distance and take breaks.
      </p>
    </section>

    <p class="advisory__note">
      {gameInfo.brand} {gameInfo.productSubtitle} is intended for children ages {gameInfo.ageRange}.
      There is no gambling, no violence, no scary content, and no adult themes.
      See the full themes list in Health, Content and Legal.
    </p>

    <button type="button" class="advisory__btn" on:click={acknowledge}>
      OK, let's play
    </button>
  </div>
</BaseScene>

<style>
  .advisory {
    max-width: 640px;
    margin: 4rem auto;
    padding: 2rem;
    text-align: left;
    font-family: var(--font-body);
    background: var(--color-surface);
    border-radius: 1rem;
  }
  .advisory__title {
    font-size: 2rem;
    color: var(--color-heading);
    text-align: center;
    margin-bottom: 1.5rem;
  }
  .advisory__section {
    margin-bottom: 1.5rem;
  }
  .advisory__section h2 {
    font-size: 1.25rem;
    color: var(--color-heading);
    margin-bottom: 0.5rem;
  }
  .advisory__note {
    color: var(--color-muted);
    font-size: 0.95rem;
    margin-bottom: 2rem;
  }
  .advisory__btn {
    display: block;
    width: 100%;
    min-height: 44px;
    padding: 1em;
    font-size: 1.25rem;
    font-weight: 600;
    background: var(--color-accent);
    color: var(--color-on-accent);
    border: none;
    border-radius: 0.5em;
    cursor: pointer;
  }
  .advisory__btn:focus-visible {
    outline: 3px solid var(--focus-ring);
    outline-offset: 2px;
  }
</style>
